import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import "./index.css"

// Onemoguci pull-to-refresh na cijeloj aplikaciji
let touchStartY = 0

document.addEventListener('touchstart', (e) => {
    touchStartY = e.touches[0].clientY
}, { passive: true })

document.addEventListener('touchmove', (e) => {
    const touchY = e.touches[0].clientY
    const touchDiff = touchY - touchStartY

    // Pronadji najblizi scrollable element u touch lancu
    let target = e.target as HTMLElement | null
    let isInsideScrollable = false
    while (target) {
        const overflowY = window.getComputedStyle(target).overflowY
        if ((overflowY === 'auto' || overflowY === 'scroll') && target.scrollHeight > target.clientHeight) {
            // Ovaj element je scrollable - dozvoli normalan scroll
            // Ali ako je vec na vrhu i korisnik vuce nadole, sprijeci pull-to-refresh
            if (target.scrollTop === 0 && touchDiff > 0) {
                e.preventDefault()
            }
            isInsideScrollable = true
            break
        }
        target = target.parentElement
    }

    // Ako nije unutar nicega scrollable, sprijeci default ponasanje (pull-to-refresh)
    if (!isInsideScrollable && touchDiff > 0) {
        e.preventDefault()
    }
}, { passive: false })

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
)